// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1qcy_","inner":"Footer_inner__3cxNq"};